import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          用户好评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          来自真实用户的观影体验分享
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg p-5 flex flex-col gap-3"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-accent-600">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <div className="flex gap-0.5 mt-0.5">
                    {Array.from({ length: item.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-primary-500"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <span className="text-xs text-foreground-400">{item.time}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}